import React from 'react';
import TemplatePage from "../template_page/template_page";
import {Page} from "../../model/page";
import Moment from "react-moment";
import C71Passthrough from "../../luiss_components/c71_passthrough/c71_passthrough";
import "./bandi_page.scss";
import {extraSmallLayout} from "../../utils/device";
import {insertHtml} from "../../utils/dom";

interface BandiPageData extends Page {
    idonei?: string;
    aggiornamento_list?: string;
    scadenza_idoneita?: string;
}

class BandiPage extends TemplatePage<BandiPageData> {

    afterRightComponentsList(page: BandiPageData): React.ReactElement | React.ReactNodeArray | React.ReactPortal | undefined {

        let layoutColumns = (!extraSmallLayout() && page.two_columns) ? 2 : 1;

        if (page.idonei) {

            return (
                <C71Passthrough layoutColumns={layoutColumns} language={this.props.language} data={ {empty: true} } >
                    <div className="bandi-page-idonei">
                        <p>Lista degli idonei:</p>
                        {page.aggiornamento_list &&
                        <><p>Ultimo aggiornamento <Moment date={page.aggiornamento_list} format="DD/MM/YYYY" /></p></>
                        }
                        <p className="content editor-html" {...insertHtml(page.idonei)} />
                        {page.scadenza_idoneita &&
                        <><p>Data di scadenza idoneità <Moment date={page.scadenza_idoneita} format="DD/MM/YYYY" /></p></>
                        }
                    </div>
                </C71Passthrough>
            );
        }
    }
}

export default BandiPage;